export function hasViewPermission(enrollment, siteId, programId, formId) {
  var permissions = getPermissionsObject(enrollment, siteId, programId, formId);
  return !!permissions && permissions.viewPerm;
}

export function hasAddPermission(enrollment, siteId, programId, formId) {
  var permissions = getPermissionsObject(enrollment, siteId, programId, formId);
  return !!permissions && permissions.addPerm;
}

export function hasEditPermission(enrollment, siteId, programId, formId) {
  var permissions = getPermissionsObject(enrollment, siteId, programId, formId);
  return !!permissions && permissions.editPerm;
}

export function getPermissionsObject(programEnrollment, siteId, programId, formId) {
  const { isFetching, err, enrollment } = programEnrollment;
  if(isFetching || err || !enrollment)
    return undefined;

  const site = enrollment && enrollment.sites && enrollment.sites.find(val => val.siteId === siteId);
  const program = site && site.programs && site.programs.find(val => val.programId === programId);
  const permissions = program && program.formPermissions && program.formPermissions.find(val => val.touchpointId === formId);
  return permissions;
}



// WEBPACK FOOTER //
// src/common/form-permissions-helpers.js